import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoicePositionListItem } from "@msuite/utils/types";
import { formatInvoiceAmount } from "@/components/incoming-invoices";

const columnHelper = createColumnHelper<IncomingInvoicePositionListItem>();

/** A quantity or a unit price, German notation, with only the decimals it carries. */
function formatDecimal(value: number | null, maximumFractionDigits: number) {
	return value === null
		? guardString(null)
		: value.toLocaleString("de-DE", { maximumFractionDigits });
}

/**
 * The positions table's columns. Amounts are shown in euros: an invoice in another currency is
 * rare enough that the column does not carry the invoice's currency per row.
 */
export const columns = [
	columnHelper.accessor("positionNumber", {
		id: "positionNumber",
		header: localized("incoming_invoices.position_number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 80,
	}),
	columnHelper.accessor("description", {
		id: "description",
		header: localized("incoming_invoices.position_description"),
		cell: (cell) => cell.getValue(),
		size: 420,
	}),
	columnHelper.accessor("quantity", {
		id: "quantity",
		header: localized("incoming_invoices.quantity"),
		cell: (cell) => formatDecimal(cell.getValue(), 3),
		size: 100,
	}),
	columnHelper.accessor("unit", {
		id: "unit",
		header: localized("incoming_invoices.unit"),
		cell: (cell) => guardString(cell.getValue()),
		size: 90,
	}),
	columnHelper.accessor("unitPrice", {
		id: "unitPrice",
		header: localized("incoming_invoices.unit_price"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), "EUR"),
		size: 130,
	}),
	columnHelper.accessor("total", {
		id: "total",
		header: localized("incoming_invoices.position_total"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), "EUR"),
		size: 130,
	}),
];
